import CardService from "src/services/CardService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {
    STORE:"cards/store"
};
export const params = {
	number:"",
	client_id:"",
	lottery_id:"",
	is_won:"",

};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.card,
@property  {array}  modules.cards
**/

const module = {
	state: {},
	mutations: {
	    [types.STORE](state,payload){
	        if (Array.isArray(payload)){
	            state.cards = [...state.cards,...payload];
            }else {
	            state.push(payload);
            }
        }
    },
	getters: {},
	actions: {},
	types: types
};
export default ModuleCreator("card", CardService, module, types ,params);
